// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import { MasterProductForm } from 'util/Types';
import styles from './CreateUpdateMasterProductForm.module.scss';
import { Form } from 'react-final-form';
import {
  handleCreateMasterProduct,
  handleUpdateMasterProduct,
} from 'apis/master_products';
import { SelectField } from '../SelectField';
import { InputDataListField } from '../InputDataListField';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import {
  validateMaxMinValue,
  validateRequiredField,
  validateStringField,
} from 'util/validator';
import { REGEX_OBJECT } from 'util/ConstantValues';

type CreateUpdateMasterProductFormProps = {
  siteName?: string;
  initialValues: Partial<MasterProductForm>;
  productId?: string;
  onUpdateCreateSuccess?: () => void;
};

const CreateUpdateMasterProductForm: React.FC<
  CreateUpdateMasterProductFormProps
> = ({ initialValues, productId, siteName, onUpdateCreateSuccess }) => {
  const { t } = useTranslation();
  const { siteId } = useParams<{ siteId: string }>();

  const handleSubmit = async (values: MasterProductForm) => {
    if (productId != null) {
      handleUpdateMasterProduct({
        id: productId,
        params: values,
        successCallback: onUpdateCreateSuccess,
      });
    } else {
      handleCreateMasterProduct({
        params: {
          ...values,
          siteId: siteId || '',
        },
        successCallback: onUpdateCreateSuccess,
      });
    }
  };

  return (
    <div className={styles.createBody}>
      <Form<MasterProductForm>
        initialValues={initialValues}
        onSubmit={handleSubmit}
        mutators={{
          setValue: ([field, value], state, { changeValue }) => {
            changeValue(state, field, () => value);
          },
        }}
        validate={(values) => ({
          name: validateStringField('製品', 50, values.name),
          weight: validateRequiredField(values.weight, '重量'),
          procurementPercentage: validateMaxMinValue({
            value: values.procurementPercentage,
            field: 'pool調達の割合',
            maxValue: 100,
            checkRequired: true,
          }),
        })}
      >
        {(props) => (
          <form onSubmit={props.handleSubmit}>
            <div className={styles.inputFrame}>
              <SelectField
                label="製品化拠点"
                name="siteName"
                placeholder="製品化拠点"
                options={
                  siteName != null
                    ? [
                        {
                          label: siteName,
                          value: siteName,
                        },
                      ]
                    : []
                }
                value={siteName}
                disabled
              />

              <InputDataListField
                label="製品"
                placeholder="製品"
                name="name"
                maxlength={50}
                required
              />

              <InputDataListField
                label="重量"
                placeholder="重量"
                name="weight"
                required
                endExtraText="kg"
                maxlength={10}
                validRegex={REGEX_OBJECT.tenDigitsWith2Decimal}
                normalizeNumber
              />

              <InputDataListField
                label="pool調達の割合"
                placeholder="pool調達の割合"
                name="procurementPercentage"
                required
                validRegex={REGEX_OBJECT.tenDigitsWith2Decimal}
                maxlength={10}
                endExtraText="%"
                normalizeNumber
              />
            </div>

            <div className={styles.submit}>
              <button
                className={
                  props.invalid ? styles.disableButton : styles.submitButton
                }
                type="submit"
              >
                {productId == null
                  ? t('common.modal_create.add_button')
                  : t('common.modal_update.edit_button')}
              </button>
            </div>
          </form>
        )}
      </Form>
    </div>
  );
};

export default CreateUpdateMasterProductForm;
